// Module
var code = `<div class="js-group-panel">
    <div class="js-group-panel-left-container">
        <div class="js-tercera-label">{{.text}}</div>
    </div>

    <div class="js-group-panel-right-container">
        <div class="hotkeys-control {{#.hasError}}container-error{{/}}" {{>visualparameters}}>
            <form autocomplete="off" on-submit="@this.onSubmitEvent(event)">
                <input type="text"
                       id="inputHotkey"
                       on-focus="focus"
                       on-blur="blur"
                       on-keydown="keyDown"
                       value="{{.value}}"
                       size="{{ (.value && .value.length ? .value.length : 6) }}"
                       as-tooltip="tooltip">
            </form>
        </div>
    </div>
</div>`;
// Exports
export default code;